var path = 'src/app/patients/mpgn/clinical-pictures.html';
var html = "<h1 class=page-header>MPGN Clinical Pictures</h1> <div mpgn-clinical-pictures-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/mpgn/clinical-pictures.html
 ** module id = 528
 ** module chunks = 0
 **/